const Test = () => {
    return (
        <div>
            테스트화면입니다.
            수빈아 ~ 열심히 하자 잘하자 ~ ㅋㅋㅋ
        </div>
    )
}

export default Test;
